export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'يوجد بالفعل حالة تنبيه بنفس الاسم في هذه المؤسسة'
    }
  }
}
